import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const colorBlock: AdminBlockTypeAttribute = {
  label: 'Show color block',
  key: 'colorBlock',
  inputType: AdminBlockAttributeInputType.COLOR_PICKER,
};

export default colorBlock;
